import React from "react"
import { Drawer } from "vaul"

import { GetStartedModalItem } from "./Item"
import { Color } from "../../../../../constants/V2/color"
import { withPrefix } from "../../../../../utils/url"
import CardMachineIcon from "../../../../elements/V2/Icons/CardMachineIcon"
import RegisterIcon from "../../../../elements/V2/Icons/RegisterIcon"
import SearchIcon from "../../../../elements/V2/Icons/SearchIcon"
import SignupIcon from "../../../../elements/V2/Icons/SignupIcon"
import Typography from "../../../../elements/V2/Typography"
import { GetStartedModalTab } from "../Modal"

import CounterIcon from "@components/elements/V2/Icons/CounterIcon"
import POSIcon from "@components/elements/V2/Icons/POSIcon"

type GetStartedModalMenuContentProps = {
  setActiveTab: (tab: GetStartedModalTab) => void
  onClose: () => void
}

export const GetStartedModalMenuTab = ({
  setActiveTab,
  onClose,
}: GetStartedModalMenuContentProps) => {
  return (
    <>
      <Drawer.Title className="mb-24 mt-40 px-[25px] md:mb-[38px] md:mt-48">
        <Typography
          weight="medium"
          color={Color.Charcoal}
          font="grotesk"
          size="lead-md"
          text="What do you want to do today?"
        />
      </Drawer.Title>
      <div className="flex flex-col">
        <GetStartedModalItem
          label="Check out Yoco Counter"
          icon={CounterIcon}
          link={withPrefix("/point-of-sale/yoco-counter")}
          onClick={onClose}
        />
        <GetStartedModalItem
          label="Sign up to Yoco"
          icon={SignupIcon}
          link={
            process.env.GATSBY_SHOP_SIGNUP_URL ||
            "https://www.yoco.com/za/signup"
          }
          onClick={onClose}
        />
        <GetStartedModalItem
          label="Help me find a product"
          icon={SearchIcon}
          link={withPrefix("/product-finder")}
          onClick={onClose}
        />
        <GetStartedModalItem
          label="Register a card machine"
          icon={RegisterIcon}
          onClick={() => setActiveTab("register")}
        />
        <GetStartedModalItem
          label="Buy a card machine"
          icon={CardMachineIcon}
          link={withPrefix("/shop/card-machines/?tab=Overview")}
          onClick={onClose}
        />
        <GetStartedModalItem
          label="Buy a point of sale"
          icon={POSIcon}
          link={withPrefix("/point-of-sale/")}
          onClick={onClose}
        />
      </div>
    </>
  )
}
